import React from 'react';
import styled, { keyframes } from 'styled-components';

const Logo = () => {
  return (
    <LogoContainer>
      <LogoSymbol>
        <OuterRing>
          <InnerRing>
            <CenterDot />
            <Graph>
              <GraphLine />
              <GraphDot />
            </Graph>
          </InnerRing>
        </OuterRing>
      </LogoSymbol>
      <LogoText>
        <PrimaryText>
          <Highlight>I</Highlight>NDIC
          <Separator />
          <Highlight>S</Highlight>IGS
        </PrimaryText>
        <SubText>Trading Signals</SubText>
      </LogoText>
    </LogoContainer>
  );
};

const graphMove = keyframes`
  0% { transform: translateX(0); }
  50% { transform: translateX(-10px); }
  100% { transform: translateX(0); }
`;

const dotPulse = keyframes`
  0% { transform: scale(1); box-shadow: 0 0 10px rgba(64, 169, 255, 0.5); }
  50% { transform: scale(1.2); box-shadow: 0 0 20px rgba(64, 169, 255, 0.8); }
  100% { transform: scale(1); box-shadow: 0 0 10px rgba(64, 169, 255, 0.5); }
`;

const ringRotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 8px;
`;

const LogoSymbol = styled.div`
  position: relative;
  width: 45px;
  height: 45px;
`;

const OuterRing = styled.div`
  position: absolute;
  inset: 0;
  border: 2px solid rgba(64, 169, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${ringRotate} 10s linear infinite;

  &::before {
    content: '';
    position: absolute;
    inset: -2px;
    border: 2px solid transparent;
    border-right: 2px solid #40A9FF;
    border-radius: 50%;
  }
`;

const InnerRing = styled.div`
  position: relative;
  width: 35px;
  height: 35px;
  border: 1px solid rgba(64, 169, 255, 0.3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CenterDot = styled.div`
  width: 6px;
  height: 6px;
  background: #40A9FF;
  border-radius: 50%;
  box-shadow: 0 0 10px rgba(64, 169, 255, 0.5);
  animation: ${dotPulse} 2s ease-in-out infinite;
`;

const Graph = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  animation: ${graphMove} 3s ease-in-out infinite;
`;

const GraphLine = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 2px;
  background: linear-gradient(to right, transparent, #40A9FF);
  transform: translate(-50%, -50%);
`;

const GraphDot = styled.div`
  position: absolute;
  top: 50%;
  right: 8px;
  width: 4px;
  height: 4px;
  background: #40A9FF;
  border-radius: 50%;
  transform: translateY(-50%);
  box-shadow: 0 0 5px #40A9FF;
`;

const LogoText = styled.div`
  display: flex;
  flex-direction: column;
`;

const PrimaryText = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  font-weight: 800;
  letter-spacing: 1px;
  color: #8B9CC8;
`;

const Highlight = styled.span`
  color: #40A9FF;
  text-shadow: 0 0 10px rgba(64, 169, 255, 0.3);
`;

const Separator = styled.div`
  width: 2px;
  height: 20px;
  background: linear-gradient(to bottom, transparent, #40A9FF, transparent);
  margin: 0 8px;
  transform: rotate(15deg);
`;

const SubText = styled.div`
  font-size: 0.7rem;
  color: #40A9FF;
  letter-spacing: 3px;
  text-transform: uppercase;
  opacity: 0.8;
  margin-top: 2px;
`;

export default Logo;